import React from 'react'
import { BrowserRouter, Route, Routes, } from "react-router-dom";
import Home from './Home';
import Register from './Register';
import AddWorkout from './AddWorkout';
import WorkoutsList from './WorkoutsList';
import ManageInstructors from './ManageInstructors';
import ManageWorkoutTypes from './ManageWorkoutTypes';
import EditWorkout from './EditWorkout';
import RegisterCompleted from './RegisterCompleted';
import Main from './Main';
import CancelRegistration from './CancelRegistration';
import ManageUsers from './ManageUsers';
import ShowManagerNotes from './ShowManagerNotes';
import ManageWorkoutParticipants from './ManageWorkoutParticipants';

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Main />}>
          <Route index element={<Home />} />
          <Route path='addWorkout' element={<AddWorkout />} />
          <Route path='manageWorkout' element={<WorkoutsList />} />
          <Route path="manageWorkout/participants/:workoutId" element={<ManageWorkoutParticipants />}>
            <Route path=':uniqueId' element={<ShowManagerNotes />} />
          </Route>
          <Route path="manageWorkout/edit/:workoutId" element={<EditWorkout />} />
          <Route path='manageInstructor' element={<ManageInstructors />} />
          <Route path='manageWorkoutTypes' element={<ManageWorkoutTypes />} />
          <Route path='manageUsers' element={<ManageUsers />} />
          <Route path="register/:workoutId" element={<Register />}>
            <Route path="cancel/:id" element={<CancelRegistration />} />
          </Route>
          <Route path='register/completed/' element={<RegisterCompleted />} />
          <Route path='register/completed/:status' element={<RegisterCompleted />} />
        </Route>
        {/* <Route path="register/:workoutId" element={<Register />} />
        <Route path="register/:workoutId/cancel/:id" element={<CancelRegistration />} />
        <Route path='register/completed/' element={<RegisterCompleted />} />
        <Route path='register/completed/:status' element={<RegisterCompleted />} /> */}
        <Route path='*' element={<h1>404</h1>} />
      </Routes>
    </BrowserRouter>)
}

export default App